/**
 * おすすめ求人から外部（yagidia ポータルなど）の求人ページへ送るときの計測パラメータを付ける。
 * どの画面・何番目の求人から来たかを、送り先のアクセス解析で見られるようにする。
 */
export function withRecommendTracking(
  url: string,
  variant: 'grid' | 'list',
  displayPosition?: number
): string {
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return url
  }
  parsed.searchParams.set('utm_source', 'rirekisho')
  // list = 出力後ダイアログ / grid = マイページの一覧
  parsed.searchParams.set(
    'utm_medium',
    variant === 'list' ? 'output_dialog' : 'mypage'
  )
  parsed.searchParams.set('utm_campaign', 'recommend_jobs')
  if (displayPosition) {
    parsed.searchParams.set('utm_content', `pos${displayPosition}`)
  }
  return parsed.toString()
}
